import { create } from 'zustand'

export const useStepStore = create(set => ({
    setStep: step => set({ step }),
    step: 1,
}))
